import React, { useState } from "react";
import {
    Paper,
    Tabs,
    Tab,
    Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import AssignmentTurnedInIcon from "@material-ui/icons/AssignmentTurnedIn";
import HistoryIcon from "@material-ui/icons/History";
import { APPROVAL_TYPES } from "../../config/approvalTypesRegistry";
import ExternalApprovalQueue from "../../components/externalApprovalQueue";
import ExternalApprovalHistory from "../../components/externalApprovalHistory";

const SITE_VISIT_TYPES = APPROVAL_TYPES.filter((t) => t.key !== "channelPartnerPayout");



const useStyles = makeStyles((theme) => ({
    page: {
        padding: theme.spacing(3),
        backgroundColor: "#f5f7fa",
        minHeight: "100vh",
    },
    header: {
        marginBottom: theme.spacing(3),
        padding: theme.spacing(3),
        background: "linear-gradient(135deg, #1A3C6E 0%, #2E75B6 100%)",
        borderRadius: theme.spacing(2),
        color: "#fff",
        boxShadow: "0 8px 32px rgba(26, 60, 110, 0.3)",
    },
    headerTitle: {
        fontWeight: 600,
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(1),
    },
    headerSubtitle: {
        opacity: 0.9,
        marginTop: theme.spacing(0.5),
    },
    tabs: {
        marginBottom: theme.spacing(3),
        backgroundColor: "#fff",
        borderRadius: theme.spacing(1),
        boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
        "& .MuiTabs-indicator": {
            height: 3,
            borderRadius: "3px 3px 0 0",
            backgroundColor: "#1A3C6E",
        },
    },
    tabLabel: {
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(1),
        fontWeight: 500,
    },
}));

const VIEWS = {
    PENDING: "pending",
    HISTORY: "history",
};

const ApprovalCenter = () => {
    const classes = useStyles();
    const [activeType, setActiveType] = useState(SITE_VISIT_TYPES[0].key);
    const [activeView, setActiveView] = useState(VIEWS.PENDING);
    const isHistory = activeView === VIEWS.HISTORY;

    return (
        <div className={classes.page}>
            <Paper className={classes.header}>
                <Typography variant="h4" className={classes.headerTitle}>
                    <AssignmentTurnedInIcon fontSize="large" />
                    Approval Center
                </Typography>
                <Typography variant="body1" className={classes.headerSubtitle}>
                    {isHistory
                        ? "Track every request and the stage it is currently in"
                        : "Review and act on pending requests awaiting your approval"}
                </Typography>
            </Paper>

            <Paper className={classes.tabs}>
                <Tabs
                    value={activeView}
                    onChange={(e, v) => setActiveView(v)}
                    indicatorColor="primary"
                    textColor="primary"
                >
                    <Tab
                        value={VIEWS.PENDING}
                        label={
                            <div className={classes.tabLabel}>
                                <AssignmentTurnedInIcon fontSize="small" />
                                Pending Approvals
                            </div>
                        }
                    />
                    <Tab
                        value={VIEWS.HISTORY}
                        label={
                            <div className={classes.tabLabel}>
                                <HistoryIcon fontSize="small" />
                                History
                            </div>
                        }
                    />
                </Tabs>
            </Paper>

            <Paper className={classes.tabs}>
                <Tabs
                    value={activeType}
                    onChange={(e, v) => setActiveType(v)}
                    indicatorColor="primary"
                    textColor="primary"
                    variant="scrollable"
                    scrollButtons="auto"
                >
                    {SITE_VISIT_TYPES.map((t) => (
                        <Tab
                            key={t.key}
                            value={t.key}
                            label={
                                <div className={classes.tabLabel}>
                                    {t.icon}
                                    {t.label}
                                </div>
                            }
                        />
                    ))}
                </Tabs>
            </Paper>

            {isHistory ? (
                <ExternalApprovalHistory typeKey={activeType} />
            ) : (
                <ExternalApprovalQueue typeKey={activeType} />
            )}
        </div>
    );
};

export default ApprovalCenter;
